var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectArrow = function SvgSelectArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.99 6.462a.71.71 0 0 1-1.257.467L5.01 2.585 1.291 6.93a.71.71 0 1 1-1.074-.922l4.255-4.973a.71.71 0 0 1 1.08 0l4.26 4.973a.7.7 0 0 1 .178.455Z"
  })));
};
export { SvgSelectArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSI4IiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik05Ljk5IDYuNDYyYS43MS43MSAwIDAgMS0xLjI1Ny40NjdMNS4wMSAyLjU4NSAxLjI5MSA2LjkzYS43MS43MSAwIDEgMS0xLjA3NC0uOTIybDQuMjU1LTQuOTczYS43MS43MSAwIDAgMSAxLjA4IDBsNC4yNiA0Ljk3M2EuNzEuNzEgMCAwIDEgLjE3OC40NTVaIi8+PC9zdmc+";